import type {Property, ParsedStyleItem} from '../types'

const getRotationValue = (value: string): string => {
    return value.replace('rotate(', '').replace('deg)', '')
}

const handleRotationProperty = (property: Property): Property => {
    if (property.cssProp === 'transform') {
        const rotateValue = getRotationValue(property.value)
        return {
            ...property,
            value: rotateValue
        }
    }
    return property
}

const getUpdatedRotationProperties = (properties: Property[]): Property[] => {
    return properties.map(property => handleRotationProperty(property))
}

const migrateIconRotation = (styleItems: ParsedStyleItem[]): ParsedStyleItem[] => {
    return styleItems.map(styleItem => {
        const {parsedStyle} = styleItem
        const updatedParsedStyle = Object.entries(parsedStyle).reduce(
            (acc, [selector, {properties, mobileProperties}]) => {
                const updatedProperties = getUpdatedRotationProperties(properties)
                const updatedMobileProperties = getUpdatedRotationProperties(mobileProperties)

                return {
                    ...acc,
                    [selector]: {
                        ...acc[selector],
                        properties: updatedProperties,
                        mobileProperties: updatedMobileProperties
                    }
                }
            },
            parsedStyle
        )

        return {
            ...styleItem,
            parsedStyle: updatedParsedStyle
        }
    })
}

export default migrateIconRotation
